module.exports = __webpack_public_path__ + "static/media/license.59759898.jpg";